/**
 * Created by alizeegod on 2018/7/26
 */
const playerState = {
    state: {
        musicInfo: {
            src: '',
            isPlayIng:'',
        },
    },
    mutations: {
        SET_MUSIC_INFO: (state, musicInfo) => {
            state.musicInfo = musicInfo
        }
    },
    actions: {
        setMusicInfo({ commit }, info) {
            commit('SET_MUSIC_INFO', info)
        },
    }
}

export default playerState
